import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character,
  // CharacterFeatureSource,
  CharacterSheetInterface,
  Modifier,
} from "@dndModels";
import { 
  SPEED_OPTIONS 
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import FloatMenu from "@components/input/menus/FloatMenu";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import { IStringHash } from "@models";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
}

const speed_map: { [speed: string]: string } = {
  "Walking": "walk",
  "Swimming": "swim",
  "Climbing": "climb",
  "Flying": "fly",
  "Burrowing": "burrow" 
}

const customization_map: { [type: string]: string } = {
  "Extra Modifiers": "Modifier",
  "Override Speeds": "Override"
};

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSpeedsButton({ 
  character,
  char_interface,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [view, setView] = useState("Features");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderSpeedFeatures = () => {
    const speed_features = character.mind.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
        ["Speed"].includes(cf.floating_feature.modifies));
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Speed Features
        </Grid>
        { speed_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = character.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id);
          if (source) {
            return (
              <Grid
                key={key}
                size={{
                  xs: 12
                }}>
                <CharacterFeatureFromSource
                  character={character}
                  obj={char_feature}
                  source={source}
                />
              </Grid>
            );
          }
          return null;
        })}
      </>
    );
  }

  const renderSpeedCustomizations = () => {
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          { view }
        </Grid>
        { Object.keys(speed_map).map((speed, key) => {
          return (
            <Grid
              key={key}
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              { renderSpeedCustomization(speed, customization_map[view]) }
            </Grid>
          );
        })}
      </>
    );
  }

  const renderSpeedCustomization = (speed: string, customization_type: string) => {
    // const use_speed = speed_map[speed];
    // const parent = char_interface.speed_customizations[use_speed];
    // const customization = parent ? parent[customization_type] : null;
    // // if (speed === "Walking") {
    // //   console.log(char_interface.speed);
    // // }
    // const the_speed = char_util.getSpeed(char_interface, use_speed);
    // return (
    //   <>
    //     <Grid
    //       size={{
    //         xs: 6
    //       }}>
    //       { speed }: { the_speed } ft.
    //     </Grid>
    //     <Grid
    //       size={{
    //         xs: customization && customization.value !== null ? 4 : 6
    //       }}>
    //       <StringBox
    //         name="Value"
    //         value={ customization && customization.value !== null ? `${customization.value}` : "" }
    //         onBlur={(changed: string) => {
    //           // debugger;
    //           if (!char_interface.speed_customizations[use_speed]) {
    //             char_interface.speed_customizations[use_speed] = { [customization_type]: { value: null, notes: "" }};
    //           } else if (!char_interface.speed_customizations[use_speed][customization_type]) {
    //             char_interface.speed_customizations[use_speed][customization_type] = { value: null, notes: "" };
    //           }
    //           if (changed === "") {
    //             delete char_interface.speed_customizations[use_speed][customization_type];
    //           } else {
    //             char_interface.speed_customizations[use_speed][customization_type].value = +changed;
    //           }
    //           character.changed();
    //           console.log("Speed Change");
    //           console.log(character);
    //           char_util.repopulateCharFeatureBases(character);
    //           setReloading(true);
    //         }}
    //       />
    //     </Grid>
    //     { customization && customization.value !== null &&
    //       <Grid
    //         size={{
    //           xs: 2
    //         }}>
    //         <StringBox
    //           name={ `Source/Notes` }
    //           value={ customization ? customization.notes : "" }
    //           onBlur={(changed: string) => {
    //             if (!character.speed_customizations[speed]) {
    //               character.speed_customizations[speed] = { [customization_type]: { value: null, notes: "" }};
    //             } else if (!character.speed_customizations[speed][customization_type]) {
    //               character.speed_customizations[speed][customization_type] = { value: null, notes: "" };
    //             }
    //             character.speed_customizations[speed][customization_type].notes = changed;
    //             character.changed();
    //             console.log("Speed Change");
    //             console.log(character);
    //             setReloading(true);
    //           }}
    //         />
    //       </Grid>
    //     }
    //   </>
    // );
    return null;
  }

  const renderView = () => {
    switch(view) {
      // case "Current": return renderCurrent();
      case "Features": return renderSpeedFeatures();
      // case "Bonus Proficiencies": return renderBonusSpeedProfs();
      default: return renderSpeedCustomizations();
    }
  }

  const options = ["Features","Extra Modifiers","Override Speeds"];
  const SPEED_map: IStringHash = {};
  const any_speeds = char_interface.mind.speed as any;
  for (const o of SPEED_OPTIONS) {
    SPEED_map[o.id] = `${o.text} ${any_speeds[o.id]} ft.`;
  }
  // console.log(SPEED_map);
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        Manage Speeds
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Display Speed"
          options={SPEED_OPTIONS.map(o => o.id)}
          display_map={SPEED_map}
          value={char_interface.mind.display_speed}
          onChange={(changed: "walk" | "swim" | "climb" | "fly" | "burrow") => {
            char_interface.mind.display_speed = changed;
            // character.changed();
            // console.log("Display Speed Change");
            // console.log(character);
            character.subscription_holder.displayChanged();
            setReloading(true);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <FloatMenu
          options={options}
          selected={view}
          onSelect={setView}
        />
      </Grid>
      { renderView() }
    </Grid>
  );
}
